<procure-expansion-panel
  flat
  condensed
  [label]="label()"
  [badge]="badge()"
>
  <div class="search-results">
    @for (item of values(); track item.id) {
      <procure-search-result-item
        [item]="item"
        [index]="$index"
        [entityType]="item.entityType"
        [showDetail]="showDetail()"
      />
    }
  </div>
</procure-expansion-panel>
